import type { ReactNode } from 'react';
import type { PillKind } from '@/lib/copy';

/**
 * Status label in AA colours (same look as StatusPill in components/ui). Always words, never colour
 * alone. `neutral` is for past or "not added" states.
 */
export function Pill({ kind = 'info', children, dot = true }: { kind?: PillKind | 'neutral'; children: ReactNode; dot?: boolean }) {
  return (
    <span className={`rides-pill ${kind}`}>
      {dot && <span className="dot" aria-hidden="true" />}
      {children}
    </span>
  );
}
